import * as React from 'react';
import OrderHistoryListingHeader from "./OrderHistory/OrderHistoryListing/OrderHistoryListingHeader/OrderHistoryListingHeader"
import OrderHistoryListing from './OrderHistory/OrderHistoryListing/OrderHistoryListing';
import ShowAlert from 'src/component/Global/ShowAlert';

const OrderHistory = () => {
    return (
        <>
            <div id="main" className="order-history-page">
                <ShowAlert />
                <div className="container-fluid maxw100">
                    <OrderHistoryListingHeader />
                    <OrderHistoryListing />
                </div>
            </div>
        </>
    );
}

export default OrderHistory;